module.exports = __webpack_public_path__ + "img/25.6c4dfbe8.jpg";